module.exports = __webpack_public_path__ + "static/media/icon_request_post_white.730e7af7.svg";